import { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { MessageSquare } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export default function SsoLanding() {
  const { ssoLogin } = useAuth();
  const navigate = useNavigate();
  const [error, setError] = useState("");
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    const token = new URLSearchParams(window.location.search).get("token");
    window.history.replaceState({}, document.title, "/sso");
    if (!token) {
      setError("Missing SSO token.");
      return;
    }
    ssoLogin(token)
      .then(() => navigate("/inbox", { replace: true }))
      .catch(() => setError("SSO sign-in failed or expired. Please use email/password login."));
  }, [ssoLogin, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center" style={{ background: "var(--cd-cream)" }}>
      <div className="card-tactile card-yellow p-7 w-[380px] pop-in" data-testid="sso-landing">
        <div className="flex items-center gap-3 mb-4">
          <div className="w-11 h-11 rounded-lg flex items-center justify-center border-2 bg-white" style={{ borderColor: "var(--cd-navy)", boxShadow: "2px 2px 0 var(--cd-navy)" }}>
            <MessageSquare size={22} strokeWidth={2.5} />
          </div>
          <div>
            <div className="font-heading font-extrabold text-2xl leading-tight">Connect Desk</div>
            <div className="font-hand text-lg text-amber-800 leading-none">arriving from SND CRM...</div>
          </div>
        </div>
        {error ? (
          <>
            <div data-testid="sso-error" className="text-sm font-semibold text-red-700 bg-red-50 border-2 border-red-200 rounded-lg px-3 py-2 mb-3">{error}</div>
            <Link to="/login" data-testid="sso-fallback-login-link" className="btn-navy w-full justify-center">Go to Login</Link>
          </>
        ) : (
          <div className="font-hand text-xl text-amber-800" data-testid="sso-loading">signing you in…</div>
        )}
      </div>
    </div>
  );
}
